import AddressType from '../enums/AddressType'
import ResidencyType from '../enums/ResidencyType'

export const getTooltipBySlug = (slug, tooltipObjects) => {
  const tooltip = tooltipObjects.find(tooltip => tooltip.attributes.field_slug === slug)
  if (tooltip) {
    return tooltip.attributes.field_body
  }
  return false
}

export const stripPhoneNumber = input => {
  return input.replace(/[()]/g, '').replace(/\s/g, '')
}

export const australianStates = [
  {
    value: 'VIC', label: 'VIC'
  },
  {
    value: 'NSW', label: 'NSW'
  },
  {
    value: 'QLD', label: 'QLD'
  },
  {
    value: 'TAS', label: 'TAS'
  },
  {
    value: 'NT', label: 'NT'
  },
  {
    value: 'WA', label: 'WA'
  },
  {
    value: 'SA', label: 'SA'
  },
  {
    value: 'ACT', label: 'ACT'
  }
]

export const getCountryByCountryCodeOrDescription = (
    countryCodeOrDescription = '',
    countries = []
  ) => {
    if (countryCodeOrDescription) {
      return countries.find(country => {
        return (
          country.countryCode === `${countryCodeOrDescription}` ||
          country.description.toLowerCase() ===
            `${countryCodeOrDescription.toLowerCase()}`
        )
      })
    }
    return null
  }

 /**
  * @param {string} description
  * @param {Array} countries
  * @returns {Array}
 */
export const findCountriesByDescription = (
  description = '',
  countries = []
) => {
  if (description) {
    return countries.filter(country => {
      return country.description
        .toLowerCase()
        .startsWith(description.toLowerCase())
    })
  }
  return []
}
  
export const mergePermanentDetails = ({
  addressLine1,
  addressLine2,
  addressLine3,
  addressType,
  country,
  city,
  state,
  postCode,
  latitude,
  longitude,
  verified,
  validationStatus
}) => {
  return {
    permanentCountry: country,
    permanentAddressLine1: addressLine1 ? addressLine1 : '',
    permanentAddressLine2: addressLine2 ? addressLine2 : '',
    permanentAddressLine3: addressLine3 ? addressLine3 : '',
    permanentSuburb: city,
    permanentState: state ? state : '',
    permanentPostcode: postCode ? postCode : '',
    permanentLatitude: latitude ? latitude : 0,
    permanentLongitude: longitude ? longitude : 0,
    permanentVerificationDate: verified ? verified : '',
    permanentValidationStatus: validationStatus ? validationStatus : ''
  }
}

export const mergeContactDetails = ({
  addressLine1,
  addressLine2,
  addressLine3,
  addressType,
  country,
  city,
  state,
  postCode,
  latitude,
  longitude,
  verified,
  validationStatus
}) => {
  return {
    contactAddressSameAsPermanentAddress: false,
    contactCountry: country,
    contactAddressLine1: addressLine1 ? addressLine1 : '',
    contactAddressLine2: addressLine2 ? addressLine2 : '',
    contactAddressLine3: addressLine3 ? addressLine3 : '',
    contactSuburb: city,
    contactState: state ? state : '',
    contactPostcode: postCode ? postCode : '',
    contactLatitude: latitude ? latitude : 0,
    contactLongitude: longitude ? longitude : 0,
    contactVerificationDate: verified ? verified : '',
    contactValidationStatus: validationStatus ? validationStatus : ''
  }
}

export const getDefaultContactAddress = (addresses = []) => {
  return addresses.find(
    ({ addressType }) => addressType === AddressType.Contact
  )
}

export const getPermanentAddressFields = ({
  permanentAddressLine1,
  permanentAddressLine2,
  permanentAddressLine3,
  permanentSuburb,
  permanentState,
  permanentPostcode,
  permanentCountry,
  permanentLatitude,
  permanentLongitude,
  permanentVerificationDate,
  permanentValidationStatus,
  insertPermanentAddressManually
}) => {
  return {
    addressLine1: permanentAddressLine1,
    addressLine2: permanentAddressLine2,
    addressLine3: permanentAddressLine3,
    city: permanentSuburb,
    state: permanentState,
    postCode: permanentPostcode,
    country: permanentCountry,
    latitude: insertPermanentAddressManually ? 0 :permanentLatitude,
    longitude: insertPermanentAddressManually ? 0 : permanentLongitude,
    verified: insertPermanentAddressManually ? '' :permanentVerificationDate,
    validationStatus: insertPermanentAddressManually ? 'MANUAL' : permanentValidationStatus
  }
}

export const getContactAddressFields = ({
  contactAddressLine1,
  contactAddressLine2,
  contactAddressLine3,
  contactSuburb,
  contactState,
  contactPostcode,
  contactCountry,
  contactLatitude,
  contactLongitude,
  contactVerificationDate,
  contactValidationStatus,
  insertContactAddressManually
}) => {
  return {
    addressLine1: contactAddressLine1,
    addressLine2: contactAddressLine2,
    addressLine3: contactAddressLine3,
    city: contactSuburb,
    state: contactState,
    postCode: contactPostcode,
    country: contactCountry,
    latitude: insertContactAddressManually ? 0 :contactLatitude,
    longitude: insertContactAddressManually ? 0 : contactLongitude,
    verified: insertContactAddressManually ? '' :contactVerificationDate,
    validationStatus: insertContactAddressManually ? 'MANUAL' : contactValidationStatus
  }
}

export const isSameAddress = (sourceAddress, targetAddress) => {
  if (sourceAddress == null || targetAddress == null) {
    return false
  }
  return (
    sourceAddress.addressLine1 === targetAddress.addressLine1 &&
    sourceAddress.addressLine2 === targetAddress.addressLine2 &&
    sourceAddress.addressLine3 === targetAddress.addressLine3 &&
    sourceAddress.city === targetAddress.city &&
    sourceAddress.state === targetAddress.state &&
    sourceAddress.postCode === targetAddress.postCode &&
    sourceAddress.country === targetAddress.country
  )
}

export const getEmergencyAddressFields = ({
  contactName,
  contactNumber,
  contactRelationship
}) => {
  return {
    emergencyContactName: contactName,
    emergencyContactNumber: contactNumber,
    relationship: contactRelationship
  }
}

export const isInternationalOnshoreStudent = (
  citizenshipCode,
  offshoreFlag
) => {
  return (
    ResidencyType.International.includes(citizenshipCode) &&
    !offshoreFlag
  )
}

export const isDomesticStudent = citizenshipCode => {
  return ResidencyType.Domestic.includes(citizenshipCode)
}

export const isInternationalStudent = citizenshipCode => {
  return ResidencyType.International.includes(citizenshipCode)
}
